import React, { useState, useRef, useEffect, useCallback } from "react";
import cn from "classnames";
import useConfig from "../../customHooks/useConfig";
import { useAccount } from "wagmi";
import styles from "./Header.module.sass";
import KadoWidgetModal from "../KadoWidgetModal";
import Icon from "../Icon";
import {
    // arbitrum,
    mainnet
} from "wagmi/chains";
// import Search from "./Search";
import Tvl from "./Tvl";
// import Messages from "./Messages";
// import Notification from "./Notification";
// import User from "./User";
import ConnectWalletModal from "../ConnectWalletModal";
import Network from "./Network";
import {
    MAINNET_BRIDGE_URL,
    ARBITRUM_BRIDGE_URL,
} from "../../utils/config";
import { useWeb3Modal } from "@web3modal/wagmi/react";

import { useDispatch, useSelector } from "react-redux";
import { setCasperActiveAccount } from "../../redux/casperSlice";

const Header = ({ onOpen, expand }) => {
    const config = useConfig();

    const click = window.csprclick;

    const dispatch = useDispatch();
    const casperActiveAccount = useSelector(state => state.casper.casperActiveAccount);
    const isCasperConnected = Boolean(casperActiveAccount);

    const [visible, setVisible] = useState(false);
    const [visibleConnect, setVisibleConnect] = useState(false);

    const [kadoWidgetVisible, setKadoWidgetVisible] = useState(false);
    const { open } = useWeb3Modal();
    const networkRef = useRef();
    const [selectedChain, setSelectedChain] = useState();

    const handleClick = () => {
        onOpen();
        setVisible(false);
    };

    const { isConnected } = useAccount();

    const {
        chainId,
    } = config;

    const openBridgeUrl = (chainId) => {
        let url = ARBITRUM_BRIDGE_URL;
        if (chainId === mainnet.id) {
            url = MAINNET_BRIDGE_URL;
        }
        window.open(
            url,
            "_blank"
        );
    }

    useEffect(() => {
        click?.on('csprclick:signed_in', async (evt) => {
            dispatch(setCasperActiveAccount(evt?.account));
        });
        click?.on('csprclick:signed_out', async (evt) => {
            dispatch(setCasperActiveAccount(null));
        });
        click?.on('csprclick:switched_account', async (evt) => {
            dispatch(setCasperActiveAccount(evt?.account));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [click?.on]);

    const handleClickConnect = useCallback(async () => {
        try {
            await click.signIn();
        } catch (error) {
            console.error('Error switching account:', error);
        }
    }, [click]);

    // Hide Buy Crypto and Bridge Crypto buttons on /liquid-staking
    const isLiquidStaking = window.location.pathname === '/liquid-staking';

    return (
        <header className={cn(styles.header, {
            [styles.expand]: expand
        })}>
            <button className={styles.burger} onClick={() => handleClick()}></button>
            {isLiquidStaking ? 
                <span className={styles.liquidStakingTitle}>
                    <img
                        src="/images/casper-text.png"
                        alt="Casper"
                        style={{ height: 24, verticalAlign: "middle", marginRight: 8 }}
                    />
                    Liquid Staking (Casper Network)
                </span>
            : (<Tvl className={cn(
                    styles.search,
                    {
                        [styles.visible]: visible
                    }
                )} />)
            }
            <button
                className={cn(
                    styles.buttonSearch,
                    {
                        [styles.active]: visible
                    }
                )}
                onClick={() => setVisible(!visible)}
            >
                <Icon name="search" size="24" />
            </button>
            <div className={styles.control} onClick={() => setVisible(false)}>
                {!isLiquidStaking && (
                    <>
                        <button
                            className={styles.link}
                            onClick={() => setKadoWidgetVisible(true)}
                        >
                            <Icon name="coin" size="24" />
                            <span className={styles.label}>
                                Buy Crypto
                            </span>
                        </button>
                        <button
                            className={styles.link}
                            onClick={() => openBridgeUrl(chainId)}
                        >
                            <Icon name="repeat" size="24" />
                            <span className={styles.label}>
                                Bridge Crypto
                            </span>
                        </button>
                    </>
                )}
                {/*<Messages className={styles.messages} />
                <Notification className={styles.notification} />*/}
                <Network ref={networkRef} onSelectedChainChange={setSelectedChain} />
                {(!isCasperConnected && selectedChain && selectedChain.chainNetwork === 'casper') ? (
                    <button
                        className={cn("button", styles.button, styles.casperConnect)}
                        style={{ background: '#e74c3c', color: '#fff' }}
                        onClick={handleClickConnect}
                    >
                        <Icon name="lightning" size="24" />
                        <span className={styles.connectWalletLabel}>
                            Connect <span className={styles.wallet}>Wallet</span>
                        </span>
                    </button>
                ) : (!isConnected && !isCasperConnected) ? (
                    <button className={cn("button", styles.button)}
                        onClick={() => open()}>
                        <Icon name="lightning" size="24" />
                        <span className={styles.connectWalletLabel}>
                            Connect <span className={styles.wallet}>Wallet</span>
                        </span>
                    </button>
                ) : null}
            </div>
            <ConnectWalletModal
                visible={visibleConnect}
                onClose={() => setVisibleConnect(false)}
            />
            <KadoWidgetModal
                visible={kadoWidgetVisible}
                onClose={() => setKadoWidgetVisible(false)}
            />
        </header >
    );
};

export default Header;
